import createActionType from "@/redux/utils/createActionType";

export const MODULE = "timeTracking/activeTimeEntries";

export const SET_IS_FETCHING_LISTS_STATUS = createActionType(MODULE, "setIsFetchingListsStatus");

export const SET_LISTS = createActionType(MODULE, "setLists");

export const SET_ACTIVE_LINE_ITEM = createActionType(MODULE, "setActiveLineItem");

export const RESET = createActionType(MODULE, "reset");

export default {};
